import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { event } from '@uhg-abyss/web/tools/event';
import PuzzleImage from '@src/common/assets/puzzle-image.svg';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { StyledLink } from '@src/common/StyledLink';
// import { AppContext } from '@src/AppContext';
import { Button } from '@uhg-abyss/web/ui/Button';

const Wrapper = styled('div', {
  minHeight: '400px',
  background: 'rgb(255, 255, 255)',
  borderRadius: '4px',
  width: '100%',
  display: 'flex',
  margin: '64px 0 0px 0',

  '@screen >= $xs': {
    flexDirection: 'column-reverse',
  },

  '@screen >= $lg': {
    flexDirection: 'row-reverse',
  },

  '@screen >= $xl': {
    flexDirection: 'row',
  },
});

const LeftCon = styled('div', {
  flexBasis: '50%',
  padding: '32px',
  margin: 'auto',
});

const RightCon = styled('div', {
  flexBasis: '50%',
});

const StyledImg = styled('img', {
  width: '100%',
  height: '100%',
});

const Title = styled('h3', {
  color: 'rgb(0, 38, 119)',
  fontSize: '28px ! important',
  fontWeight: '600',
  lineHeight: '32px',
  marginBottom: '16px',
});

const Description = styled('p', {
  color: 'rgb(51, 51, 51)',
  fontSize: '15px',
  fontWeight: 400,
  letterSpacing: '0px',
  lineHeight: '24px',
  overflow: 'hidden',
  maxHeight: '237px',
});

const LinkBox = styled('div', {
  letterSpacing: '0px',
  display: 'flex',
  alignItems: 'center',
  height: '20px',
  color: 'rgb(25, 110, 207)',
  fontSize: '15px',
  fontWeight: 'bold',
  lineHeight: '20px',
  marginTop: '40px',

  a: {
    '&:hover': {
      textDecoration: 'none',
    },
  },
});

export const GettingStarted = () => {
  const { navigate } = useRouter();
  // const { filters, updateFilters } = React.useContext(AppContext);
  const onApiClicked = async (filterTitle) => {
    // const newFilters = filters.map((el) => {
    //   const checked = el.title === filterTitle;
    //   return {
    //     ...el,
    //     checked,
    //   };
    // });
    // await updateFilters(newFilters);
    navigate({
      pathname: 'all-apis',
      // state: { filter: filterTitle },
    });
  };
  const onGettingStartedClick = () => {
    const interactionName = 'super connector api';
    const interactionValue = 'view apis';
    const interactionContext = 'page cta link clicks';
    event('INTERACTION_EVENT', {
      interactionName,
      interactionValue,
      interactionContext,
    });
    onApiClicked('Super Connector');
  };
  return (
    <Wrapper>
      <LeftCon>
        <Title>Start up with APIs</Title>
        <Description>
          Learn how you can get started working with APIs, from downloading our
          self-paced user guide and understanding the steps, plus the range of
          benefits that API integration can bring to your practice.
        </Description>
        <LinkBox>
          <Button
            onClick={onGettingStartedClick}
            fontWeight="$bold"
            id="getStarted"
          >
            View APIs
          </Button>
        </LinkBox>
      </LeftCon>
      <RightCon>
        <StyledLink variant="custom" onClick={onGettingStartedClick}>
          <StyledImg src={PuzzleImage.src} />
        </StyledLink>
      </RightCon>
    </Wrapper>
  );
};
